const TimingValues = {
    Fast: 100,
    Default: 300,
    Medium: 500,
    Long: 1000,
    Heavy: 2000,
};

export { TimingValues };
